import { AnimatePresence, motion } from 'motion/react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { useGetParams } from '../../hooks/useGetParams';

import { WinnerTitle } from './WinnerTitle';
import { Message } from '../Message/Message';
import { Confetti } from '../Confetti/Confetti';

import styles from './MessagesList.module.css';

export const MessagesList = ({
  messages,
  currentState,
  winId,
  speed,
  messagesRef,
}) => {
  const { authorFontSize } = useGetParams();

  const isWinner =
    currentState === 'S7' ||
    (currentState === 'S4' && messagesRef?.length === 1);

  return (
    <motion.div className={styles.wrapper}>
      <AnimatePresence mode={'wait'}>
        {isWinner && (
          <div className={styles.winnerTitleBlock}>
            <motion.div
              initial={{ scaleX: 0, originX: '0%' }}
              animate={{
                scaleX: 1,
                originX: '0%',
                transition: { duration: 0.7, delay: 0.2 + 0.5 },
              }}
              exit={{ opacity: 0, transition: { duration: 0.5, delay: 0 } }}
              className={styles.winnerTitleBg}
            />
            <WinnerTitle className={styles.firstLine} startDelay={0.5} />
          </div>
        )}
      </AnimatePresence>

      {currentState === 'S4' ? (
        messagesRef?.length === 1 ? (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.3, 1] }}
            transition={{ duration: 1 }}
            style={{ marginTop: '20rem' }}
          >
            <Message
              message={messagesRef[0].message}
              currentState={currentState}
              winId={messagesRef[0].message?.id}
              authorFontSize={authorFontSize}
            />
          </motion.div>
        ) : null
      ) : (
        <div className={styles.messagesWrapper}>
          <TransitionGroup className={styles.messages}>
            {messages.length > 0 &&
              messages.map((item, i) => (
                <CSSTransition
                  key={item.UUID}
                  timeout={speed}
                  classNames="position"
                >
                  <Message
                    winId={winId}
                    key={item.id}
                    message={item.message}
                    titrTag={item.titrTag}
                    authorFontSize={authorFontSize}
                    currentState={currentState}
                  />
                </CSSTransition>
              ))}
          </TransitionGroup>
        </div>
      )}

      {isWinner && <Confetti />}
    </motion.div>
  );
};
